import {
  IManagerUiSettings,
  SOUND_NOTIFICATIONS_ENABLED_DEFAULT
} from './client';
import { ManagerUiSettingsServer } from './server';

export const normalizeManagerUiSettings = (
  raw: ManagerUiSettingsServer
): IManagerUiSettings => ({
  // менеджер мог ни разу не менять настройку — тогда ключа в ui_settings нет
  soundNotificationsEnabled:
    raw.ui_settings?.sound_notifications_enabled ??
    SOUND_NOTIFICATIONS_ENABLED_DEFAULT
});
